module.exports = __webpack_public_path__ + "static/media/battleship.ab3d417e.png";